module.exports = __webpack_public_path__ + "static/og-891e95ad34ed997c5af767f9c4a7f896.png";